import ReferencePathService from '~/services/referencePathServices/referencePathService'
import {
  IReferencePathNodeApiDynamicInput,
  IReferencePathNodeApiEndPoint,
  IReferencePathNodeSpecific
} from '~/interfaces/referencePathInterfaces'
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'
import DynamicInput from '~/models/dynamicInput'
import { ReferenceNodeType } from '~/enums/referenceNodeType'

export default class ApiDynamicInputPathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.DynamicInput

  constructor(private dynamicInputNode: IReferencePathNodeApiDynamicInput) {
    super()
  }

  get label(): string {
    return this.dynamicInputNode.reference()?.name
  }

  get nodes(): IReferencePathNodeApiDynamicInput[] {
    return [this.dynamicInputNode]
  }

  reference(): DynamicInput {
    return DynamicInput.repo.findBy((di) => di.id === this.dynamicInputNode.reference_id)
  }

  get referenceGenericModelType(): GenericType {
    return this.reference()?.genericType
  }

  get referenceModelType(): ModelType {
    return this.reference()?.modelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    if (!node) return true
    if (node.reference_type !== ReferenceNodeType.DynamicInput) return false
    const decision = this.reference().certificateDynamicInputs.some((di) => di.id === node.reference_id)
    this.debugCanLinkTo('ApiEndPointPathService', this.dynamicInputNode, node, decision)
    return decision
  }

  get referenceIsCollection(): boolean {
    return this.reference().isList
  }

  get referenceIsAppendable(): boolean {
    return this.reference().isList || this.referenceIsText();
  }
}